import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from '@angular/router';

import { FeatureFlagService } from '@core/services/feature-flag.service';
import { FeatureFlag } from '@env/environment.interface';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagGuard implements CanActivate {
  constructor(private readonly featureFlagService: FeatureFlagService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const featureFlag = route.data.featureFlag as FeatureFlag;
    if (featureFlag) {
      return this.featureFlagService.isEnabled(featureFlag);
    }

    return false;
  }
}
